import classNames from 'classnames';
import React from 'react';

import {
  EMBED_OWNER_INFO_CLICK,
  EMBED_TITLE_CLICK,
  EMBED_WATCH_ON_LOOM_CLICK,
} from 'constants/events';
import { LOOM_PROD_URI, LOOM_STAGE_URI, LOOM_URI } from 'constants/routes';
import * as analytics from 'utilities/analytics';

import EmbedTopBarShareButton from './share-button';
import { EmbedContext } from '../../embed-video';
import { ROLLOUT_EMBED_VIDEO_TOP_BAR } from '../../../../../shared/constants/featureFlag';

import FeatureFlaggedComponent from 'components/feature-flag-wrapper';

import './styles.less';

const MAX_NAME_LENGTH = 20;

export default function EmbedTopBar(props) {
  // we check the production Loom URI too because we embed our production
  // videos in various parts of our onboarding experiences
  const fromAnyLoomPage =
    props.fromPublicSharePage ||
    props.parentLocation.indexOf(LOOM_URI) > -1 ||
    props.parentLocation.indexOf(LOOM_PROD_URI) > -1 ||
    props.parentLocation.indexOf(LOOM_STAGE_URI) > -1;

  function onTitleClick() {
    analytics.track(EMBED_TITLE_CLICK, {
      from_link_expand: props.fromLinkExpand,
      parent_location: props.parentLocation,
      video_id: props.videoModel.id,
      title: props.videoName,
    });
  }

  function onOwnerClick() {
    analytics.track(EMBED_OWNER_INFO_CLICK, {
      from_link_expand: props.fromLinkExpand,
      parent_location: props.parentLocation,
      video_id: props.videoModel.id,
    });
  }

  function watchOnLoomClick() {
    analytics.track(EMBED_WATCH_ON_LOOM_CLICK, {
      from_link_expand: props.fromLinkExpand,
      parent_location: props.parentLocation,
      video_id: props.videoModel.id,
    });
  }

  const shareUrl = `${LOOM_URI}/share/${props.videoModel.id}`;

  return (
    <EmbedContext.Consumer>
      {({ hideOwner, hideTitle, hideShare }) => (
        <FeatureFlaggedComponent
          flag={ROLLOUT_EMBED_VIDEO_TOP_BAR}
          activationValue={true}
        >
          <div
            className={classNames('embed-screen-top-section', {
              'cta-enabled': props.ctaEnabled,
              started: props.hasStarted,
              ended: props.ended,
            })}
          >
            {!hideTitle && (
              <a
                onClick={onTitleClick}
                href={shareUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={classNames('title', {
                  'cta-enabled': props.ctaEnabled,
                })}
              >
                {props.videoName}
              </a>
            )}
            <div className="sub-title-section">
              {!hideOwner && (
                <>
                  <img src={props.pauseScreenAvatar} align="left" />
                  <a
                    onClick={onOwnerClick}
                    href={shareUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="owner-name"
                  >
                    {/* enforce to 20 characters */}
                    {props.ownerFullname.length > MAX_NAME_LENGTH
                      ? props.ownerFullname.substring(0, MAX_NAME_LENGTH) +
                        '...'
                      : props.ownerFullname}
                  </a>
                </>
              )}
              {props.loomBrandedPlayer && !fromAnyLoomPage && (
                <a
                  onClick={watchOnLoomClick}
                  href={shareUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classNames(
                    'watch-on-loom',
                    hideOwner && 'owner-hidden'
                  )}
                >
                  Watch on Loom
                </a>
              )}
            </div>
            {!hideShare && (
              <EmbedTopBarShareButton
                hasGmailAccount={props.hasGmailAccount}
                videoIsTeamShared={props.videoIsTeamShared}
                currentUserIsOwner={props.currentUserIsOwner}
                video={props.videoModel}
              />
            )}
          </div>
        </FeatureFlaggedComponent>
      )}
    </EmbedContext.Consumer>
  );
}
